<template>
    <div>
			<base-dialog v-model="companyCodeInfoMessagesModalVisible" :dontShowAgainCookie="COMPANY_CODE_INFO_MESSAGES_COOKIE_NAME">
				<!-- <b-row v-if="$store.getters.getCompanyCodeInfoMessages && $store.getters.getCompanyCodeInfoMessages.length > 0" class="mb-4">
					<b-alert show v-for="msg in $store.getters.getCompanyCodeInfoMessages" :key="$store.getters.getCompanyCodeInfoMessages[msg]" variant="info" dismissible class="shadow">
						{{ msg }}
					</b-alert>
				</b-row> -->
				<b-alert show v-for="translation in $store.getters['session/companyCodeInfoMessages']" :key="$store.getters['session/companyCodeInfoMessages'][translation]" variant="info-dialog" class="shadow">
					{{ $i18nHelpers.normalize(translation) }}
				</b-alert>
			</base-dialog>
			<health-sliders-modal v-if="showHealthSlidersModal"></health-sliders-modal>
        <b-row class="neu-cards-ctn" cols="1" cols-xl="4">
            <PatientPanelServiceBlock v-for="block in blocks" :id="block.id" :title="block.title" :description="block.description" :img="block.img" :action="block.action" :enabled="block.enabled" :visible="block.visible" :active="block.active" :key="block.id" :iconSize="block.iconSize" :clickOnceEnabled="block.clickOnceEnabled" :soonLabel="block.soonLabel"/>
        </b-row>
        <base-dialog v-model="testsDialog.visible" :content="$t('patient-panel.evaluateYourHealthWarning')" :okFn="async () => { goTests() }" :cancelFn="() => { testsDialog.visible = false }" :dontShowAgainCookie="testsDialog.cookie" :dontShowAgainCookieExpirationDays="90"></base-dialog>
    </div>
</template>

<script>
import PatientPanelServiceBlock from '@/components/PatientPanelServiceBlock'
import { WELLWO_SERVICE, OPENSALUD_PRIME_SERVICE } from '@/constants/patientServices'
import Vue from 'vue'
import appHelpers from '@/helpers/app.helpers'
import BaseDialog from '@/components/base/BaseDialog'
import companyServicesMixin from '@/mixins/companyServices.mixin'
import { EVALUATE_YOUR_HEALTH_WARNING_COOKIE, COMPANY_CODE_INFO_MESSAGES_COOKIE_NAME } from '@/constants/cookies'
import { BAlert } from 'bootstrap-vue'
import { getCookie } from '@/helpers/cookies.helpers'
import { UPDATE_HEALTH_QUESTIONNAIRE_ACTION } from '@/constants/loginOptionalActions'
import HealthSlidersModal from '@/components/webapp/shared/HealthSlidersModal.vue'

export default {
    name: 'PatientPanelBlocks',
    mixins: [companyServicesMixin],
    components: {
        PatientPanelServiceBlock,
				BaseDialog,
				BAlert,
				HealthSlidersModal
                },
    methods: {
        goTests () {
            this.$router.push('/patient/tests')
        }
    },
    data () {
        return {
            testsDialog: {
                visible: false,
                cookie: EVALUATE_YOUR_HEALTH_WARNING_COOKIE
            },
						COMPANY_CODE_INFO_MESSAGES_COOKIE_NAME,
						companyCodeInfoMessagesModalVisible: false
        }
    },
		mounted () {
			this.companyCodeInfoMessagesModalVisible = this.showCompanyCodeInfoMessagesModal
		},
    props: {
        companyServices: {
            type: Array,
            required: false,
            default () {
                return this.$store.state.session.user && this.$store.state.session.user.activeCompanyServices ? this.$store.state.session.user.activeCompanyServices : null
            }
        }
    },
    computed: {
        wellwoBlock () {
            const service = this.companyServices ? this.companyServices.find(service => service.id === WELLWO_SERVICE) : null
						const serviceName = (service ? this.$i18nHelpers.normalize(service.alternativeName) : null) || this.$t('patient-panel.health-wealth')
            /* const _this = this */
            return {
                id: WELLWO_SERVICE,
                title: serviceName,
                description: this.$t('patient-panel.health-wealth-description'),
                img: '/static-appopensalud/img/icons/morillas-svg-icons/primary/wellness.svg',
                // Lambda function to avoid the click event to be triggered when the block is disabled
								action: () => {
									this.$store.commit('setLoading', true)
									this.goToWellwo()
									this.$store.commit('setLoading', false)
								},
                active: service && service.active,
								clickOnceEnabled: true
            }
        },
        habitsBlock () {
            return {
                id: 'healthyHabits',
                title: this.$t('patient-panel.healthy-habits'),
                description: this.$t('patient-panel.habits-description'),
                img: '/static-appopensalud/img/icons/morillas-svg-icons/primary/goals.svg',
                action: () => {
									this.$router.push('/patient/goals-habits-menu')
                },
                visible: true
            }
        },
				foodsBlock () {
					return {
							id: 'habits',
							title: this.$t('patient-panel.foods'),
							description: this.$t('patient-panel.foods-description'),
							img: '/static-appopensalud/img/icons/morillas-svg-icons/primary/alimentos.png',
							action: () => {
								this.$router.push('/patient/healthy-food-menu')
							},
							visible: true
					}
        },
        healthDataBlock () {
					return {
							id: 'health-data',
							title: this.$t('patient-panel.health-data'),
							/* description: this.$t('patient-panel.health-data-description', { param: female ? `, ${this.$t('patient-panel.menstrual-calendar').toLowerCase()}` : '' }), */
							description: this.$t('patient-panel.health-data-description'),
							img: '/static-appopensalud/img/icons/morillas-svg-icons/primary/clinic-history.svg',
							action: () => {
								this.$router.push('/patient/clinic-history')
							},
							visible: true
					}
        },
        opensaludPrimeBlock () {
            const service = this.companyServices ? this.companyServices.find(service => service.id === OPENSALUD_PRIME_SERVICE) : null
						const serviceName = (service ? this.$i18nHelpers.normalize(service.alternativeName) : null) || this.$t('patient-panel.bonified-services')
            /* const _this = this */
            return {
                id: OPENSALUD_PRIME_SERVICE,
                title: serviceName,
                description: this.$t('patient-panel.bonified-services-description'),
                img: '/static-appopensalud/img/icons/morillas-svg-icons/primary/creditcard.svg',
                action: () => {
									this.$store.commit('setLoading', true)
									this.goToOpensaludPrime(Vue.prototype.$apiToken)
									this.$store.commit('setLoading', false)
                },
                active: service && service.active,
								clickOnceEnabled: true
            }
        },
        forumBlock () {
            const _this = this
            return {
                id: 'forum',
                title: (_this.$store.getters['session/healthyCommunityActive'] ? this.$t('patient-panel.healthy-community') : this.$t('patient-panel.patients-like-you')),
                description: this.$t('patient-panel.healthy-community-description'),
                img: '/static-appopensalud/img/icons/morillas-svg-icons/primary/healthy-community.svg',
                action () {
                    if (_this.$store.getters['session/healthyCommunityActive']) {
                        _this.goToHealthyCommunity()
                    } else {
                        appHelpers.goToForum()
                    }
                },
                visible: true
            }
        },
        searchBlock () {
            const _this = this
            return {
                id: 'Search',
                title: this.$t('patient-panel.teleconsultation'),
                description: this.$t('patient-panel.teleconsultation-description'),
                img: '/static-appopensalud/img/icons/morillas-svg-icons/primary/medic.svg',
                action () {
                    _this.$router.push('/patient/appointments-menu')
                },
                visible: true
            }
        },
				careHabitsBlock () {
					return {
						id: 'blog',
						title: this.$t('patient-panel.habits-that-care'),
						description: this.$t('patient-panel.habits-that-care-description'),
						img: '/static-appopensalud/img/icons/morillas-svg-icons/primary/habitos.png',
						visible: true,
						iconSize: '40',
						action () {
							this.$router.push('/patient/microhabits')
						}
					}
				},
				myAppsBlock () {
					return {
						id: 'my-apps',
						title: this.$t('patient-panel.my-apps'),
						description: this.$t('patient-panel.my-apps-description'),
						img: '/static-appopensalud/img/icons/morillas-svg-icons/primary/my-apps2.svg',
						visible: true,
						action () {
							this.$router.push('/patient/my-apps')
						}
					}
				},
				testsBlock () {
					const _this = this
					return {
						id: 'tests',
						title: this.$t('patient-panel.self-evaluation-tests'),
						description: this.$t('patient-panel.self-evaluation-tests-description'),
						img: '/static-appopensalud/img/icons/morillas-svg-icons/primary/opensaludhealthy-tests.svg',
						action () {
								if (getCookie(_this.testsDialog.cookie)) {
										_this.goTests()
								} else {
										_this.testsDialog.visible = true
								}
						},
						visible: true
					}
				},
        blocks () {
					// Current order: Search, Tests, Wellwo (if active), Opensaludprime (if active), Habits, Foods, Health data, My apps, Forum, Care habits
					const blocks = [
						this.searchBlock,
						this.testsBlock
					]
					if (this.wellwoBlock.active) {
						blocks.push(this.wellwoBlock)
					}
					if (this.opensaludPrimeBlock.active) {
						blocks.push(this.opensaludPrimeBlock)
					}
					blocks.push(
						this.habitsBlock,
						this.foodsBlock,
						this.healthDataBlock,
						this.myAppsBlock,
						this.forumBlock,
						this.careHabitsBlock
					)
					// Max 8 blocks
					return blocks.slice(0, 8)
        },
				showCompanyCodeInfoMessagesModal () {
					return this.$store.getters['session/companyCodeInfoMessages'] && this.$store.getters['session/companyCodeInfoMessages'].length > 0
				},
				showHealthSlidersModal () {
					return this.$store.state.session.loginOptionalActions && this.$store.state.session.loginOptionalActions.includes(UPDATE_HEALTH_QUESTIONNAIRE_ACTION)
				}
    }
}
</script>

<style lang="scss" scoped>
.survey-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
}

.survey-link {
    color: blue;
    font-weight: bold;
    text-decoration: underline;
    cursor: pointer;
    display: inline-block;
    margin-top: 10px;
}

.survey-link:hover {
    text-decoration: none;
    color: #1a1aff;
}
@include media(tablets, mobile) {
    .neu-cards-ctn {
        padding: {
						top: 1rem;
            left: 0rem !important;
            right: 0rem !important;
        }
    }

		.neu-card {
			text-align: left;
			max-width: 260px;
			margin: 0 auto;
		}
}
</style>


// WEBPACK FOOTER //
// src/components/PatientPanelBlocks.vue